// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Paywall Items */
.element-paywall-items {
    width: 100%;
    margin: 20px 0;
}

.paywall-plans-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
}

.paywall-plan-card {
    position: relative;
    width: 100%;
}

.paywall-badge-container {
    position: absolute;
    top: -10px;
    left: 20px;
    z-index: 10;
}

.paywall-badge {
    background-color: #A145B0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 700;
    padding: 4px 12px;
    border-radius: 6px;
}

.paywall-plan-button {
    width: 100%;
    background-color: #1A1A1A;
    border: 2px solid rgba(17, 17, 17, 0.08);
    border-radius: 12px;
    padding: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.paywall-plan-button:hover {
    transform: scale(1.02);
}

.paywall-plan-button.selected {
    border-color: #A145B0;
    background-color: #1A1A1A;
}

.paywall-plan-body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.paywall-plan-details {
    flex: 1;
    text-align: left;
}

.paywall-plan-title {
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 8px;
}

.paywall-plan-prices {
    display: flex;
    align-items: center;
    gap: 8px;
}

.paywall-old-price {
    font-size: 16px;
    font-weight: 500;
    color: #7A7A7A;
    text-decoration: line-through;
}

.paywall-new-price {
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
}

.paywall-price-block {
    position: relative;
    width: 104px;
    height: 46px;
    flex-shrink: 0;
}

.paywall-price-shape {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: rgba(170, 170, 170, 0.4);
}

.paywall-plan-button.selected .paywall-price-shape {
    color: #A145B0;
}

.paywall-price-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 12px;
}

.paywall-price-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
}

.paywall-currency {
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

.paywall-int-digits {
    font-size: 36px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

.paywall-fraction-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
}

.paywall-fraction-digits {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1;
}

.paywall-price-label {
    font-size: 10px;
    font-weight: 500;
    color: #ffffff;
    line-height: 1;
}

/* Paywall Buttons */
.paywall-primary-button-container {
    width: 100%;
    margin-top: 20px;
    padding: 0;
}

.paywall-primary-button {
    width: 100%;
    background-color: #A145B0;
    color: #FFFFFF;
    border: none;
    border-radius: 10px;
    padding: 16px 24px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.paywall-primary-button:hover {
    background-color: #8F3B9F;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(161, 69, 176, 0.3);
}

.paywall-primary-button:active {
    transform: translateY(0);
}

.paywall-secondary-button-container {
    width: 100%;
    margin-top: 10px;
    padding: 0;
}

.paywall-secondary-button {
    width: 100%;
    background-color: #000000;
    color: #EAEAEA;
    border: none;
    border-radius: 10px;
    padding: 10px 24px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.paywall-secondary-button:hover {
    background-color: #1A1A1A;
    transform: translateY(-1px);
}

.paywall-secondary-button:active {
    transform: translateY(0);
}

.paywall-description-container {
    width: 100%;
    margin-top: 10px;
    padding: 0 20px;
}

.paywall-description {
    font-size: 12px;
    font-weight: 400;
    color: #7A7A7A;
    line-height: 1.5;
    text-align: left;
}

.paywall-description a {
    color: #FFFFFF;
    text-decoration: none;
}

.paywall-description a:hover {
    text-decoration: underline;
}

/* Payment Form */
.element-payment-form {
    width: 100%;
    margin: 0px 0;
}

.payment-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.payment-element {
    width: 100%;
    min-height: 100px;
}

.payment-submit-button {
    width: 100%;
    background-color: #A145B0;
    color: #FFFFFF;
    border: none;
    border-radius: 10px;
    padding: 16px 24px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
}

.payment-submit-button:hover:not(:disabled) {
    background-color: #8F3B9F;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(161, 69, 176, 0.3);
}

.payment-submit-button:active:not(:disabled) {
    transform: translateY(0);
}

.payment-submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.payment-spinner {
    width: 20px;
    height: 20px;
    border: 3px solid rgba(255, 255, 255, 0.3);
    border-top-color: #FFFFFF;
    border-radius: 50%;
    animation: payment-spinner-rotate 0.8s linear infinite;
}

.payment-spinner.hidden,
.payment-button-text.hidden,
.payment-message.hidden {
    display: none;
}

.payment-button-text {
    display: inline-block;
}

.payment-message {
    width: 100%;
    padding: 12px 16px;
    background-color: #1A1A1A;
    border: 1px solid #333333;
    border-radius: 8px;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 1.4;
}

.payment-message.error {
    background-color: #2A1A1A;
    border-color: #ff6b6b;
    color: #ff6b6b;
}

/* Payment Accordion */
.accordion {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0px;
}

.accordion .item {
    margin-bottom: 8px;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion .item:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.accordion .item[data-state="hidden"] {
    margin-bottom: 0px;
    display: none;
    height: 0px;
}

.accordion .trigger {
    width: 100%;
    background: transparent;
    border: 0;
    padding: 20px 14px;
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    color: #333;
    font-size: 16px;
    transition: all 0.2s ease;
}

.accordion .trigger:hover {
    background: #f8f8f8;
}

.accordion .item[data-state="expanded"] .trigger {
    background: transparent;
}

.accordion .radio-circle {
    width: 24px;
    height: 24px;
    border: 2px solid #d0d0d0;
    border-radius: 50%;
    position: relative;
    flex-shrink: 0;
    transition: all 0.2s ease;
}

.accordion .item[data-state="expanded"] .radio-circle {
    border-color: #333;
    border-width: 2px;
}

.accordion .item[data-state="expanded"] .radio-circle::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    background: #333;
    border-radius: 50%;
}

.accordion .payment-icons {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
}

.accordion .image-wrap {
    display: inline-flex;
    align-items: center;
}

.accordion .payment-method-icon {
    height: 24px;
    width: auto;
}

.accordion .panel-wrapper {
    height: 0;
    overflow: hidden;
    transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion .panel {
    color: #666;
    font-size: 14px;
    line-height: 1.6;
    padding: 0 12px;
}

.accordion .bullets {
    list-style: none;
    padding: 0 10px;
    margin: 16px 0;
}

.accordion .bullet {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 12px;
    color: #000;
    font-size: 14px;
    line-height: 1.5;
}

.accordion .bullet span {}

.accordion .bullet svg {
    flex-shrink: 0;
    margin-top: 2px;
}

.accordion .checkmark {
    stroke: #000;
}

.accordion .container.svelte-ykx1g {
    margin: 16px 0;
}

.accordion button.svelte-1wws8ka {
    line-height: 1.3;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background-color: #000;
    border-radius: 16px;
    border-width: 0;
    border-style: solid;
    width: 100%;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-top: 16px;
    margin-bottom: 16px;
    transition: all 0.2s ease;
}

.accordion button.svelte-1wws8ka:hover {
    background: #333;
    transform: translateY(-1px);
}

.accordion .svelte-lss1u3 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.accordion .footer {
    font-size: 14px;
    line-height: 1;
    text-align: center;
    color: #999;
    margin-bottom: 16px;
}

/* Card element */
#card-element {
    background: #fff;
    border-radius: 8px;
    min-height: 50px;
    margin-bottom: 16px;
}

#card-errors {
    color: #ff6b6b;
    font-size: 14px;
    margin-top: 8px;
    min-height: 20px;
}

#pay-btn {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #000;
    color: #fff;
    margin-left: auto;
    margin-right: auto;
    cursor: pointer;
    font-weight: 500;
    font-size: 15px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    transition: all 0.2s ease;
}

#pay-btn:hover:not(:disabled) {
    background: #333;
    transform: translateY(-1px);
}

#pay-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Payment loader spinner */
#payment-form-loader.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 40px auto;
}

.applePayButton {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.other-payment-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    width: 100%;
    background-color: #000000;
    color: #EAEAEA;
    border: none;
    border-radius: 10px;
    padding: 10px 0px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: center;
}

.other-payment-button h1 {
    font-size: clamp(2px, 16px, 16px);
    white-space: nowrap;
}

#solid-payment-form-iframe {
    width: 100%;
}

#gpay-button-online-api-id {
    border-radius: 10px;
}

#apple-pay {
    border-radius: 10px;
}

.apple-pay-button-white {
    background: #A145B0;
}

apple-pay-button {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/payment.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,MAAM;AACV;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,WAAW;IACX,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;;AAEzB;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* Paywall Items */\n.element-paywall-items {\n    width: 100%;\n    margin: 20px 0;\n}\n\n.paywall-plans-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.paywall-plan-card {\n    position: relative;\n    width: 100%;\n}\n\n.paywall-badge-container {\n    position: absolute;\n    top: -10px;\n    left: 20px;\n    z-index: 10;\n}\n\n.paywall-badge {\n    background-color: #A145B0;\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 700;\n    padding: 4px 12px;\n    border-radius: 6px;\n}\n\n.paywall-plan-button {\n    width: 100%;\n    background-color: #1A1A1A;\n    border: 2px solid rgba(17, 17, 17, 0.08);\n    border-radius: 12px;\n    padding: 18px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n}\n\n.paywall-plan-button:hover {\n    transform: scale(1.02);\n}\n\n.paywall-plan-button.selected {\n    border-color: #A145B0;\n    background-color: #1A1A1A;\n}\n\n.paywall-plan-body {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.paywall-plan-details {\n    flex: 1;\n    text-align: left;\n}\n\n.paywall-plan-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 8px;\n}\n\n.paywall-plan-prices {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.paywall-old-price {\n    font-size: 16px;\n    font-weight: 500;\n    color: #7A7A7A;\n    text-decoration: line-through;\n}\n\n.paywall-new-price {\n    font-size: 18px;\n    font-weight: 600;\n    color: #ffffff;\n}\n\n.paywall-price-block {\n    position: relative;\n    width: 104px;\n    height: 46px;\n    flex-shrink: 0;\n}\n\n.paywall-price-shape {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    color: rgba(170, 170, 170, 0.4);\n}\n\n.paywall-plan-button.selected .paywall-price-shape {\n    color: #A145B0;\n}\n\n.paywall-price-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-left: 12px;\n}\n\n.paywall-price-wrap {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.paywall-currency {\n    font-size: 16px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n\n.paywall-int-digits {\n    font-size: 36px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n\n.paywall-fraction-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0;\n}\n\n.paywall-fraction-digits {\n    font-size: 14px;\n    font-weight: 700;\n    color: #ffffff;\n    line-height: 1;\n}\n\n.paywall-price-label {\n    font-size: 10px;\n    font-weight: 500;\n    color: #ffffff;\n    line-height: 1;\n}\n\n/* Paywall Buttons */\n.paywall-primary-button-container {\n    width: 100%;\n    margin-top: 20px;\n    padding: 0;\n}\n\n.paywall-primary-button {\n    width: 100%;\n    background-color: #A145B0;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 10px;\n    padding: 16px 24px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.paywall-primary-button:hover {\n    background-color: #8F3B9F;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(161, 69, 176, 0.3);\n}\n\n.paywall-primary-button:active {\n    transform: translateY(0);\n}\n\n.paywall-secondary-button-container {\n    width: 100%;\n    margin-top: 10px;\n    padding: 0;\n}\n\n.paywall-secondary-button {\n    width: 100%;\n    background-color: #000000;\n    color: #EAEAEA;\n    border: none;\n    border-radius: 10px;\n    padding: 10px 24px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.paywall-secondary-button:hover {\n    background-color: #1A1A1A;\n    transform: translateY(-1px);\n}\n\n.paywall-secondary-button:active {\n    transform: translateY(0);\n}\n\n.paywall-description-container {\n    width: 100%;\n    margin-top: 10px;\n    padding: 0 20px;\n}\n\n.paywall-description {\n    font-size: 12px;\n    font-weight: 400;\n    color: #7A7A7A;\n    line-height: 1.5;\n    text-align: left;\n}\n\n.paywall-description a {\n    color: #FFFFFF;\n    text-decoration: none;\n}\n\n.paywall-description a:hover {\n    text-decoration: underline;\n}\n\n/* Payment Form */\n.element-payment-form {\n    width: 100%;\n    margin: 0px 0;\n}\n\n.payment-form {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.payment-element {\n    width: 100%;\n    min-height: 100px;\n}\n\n.payment-submit-button {\n    width: 100%;\n    background-color: #A145B0;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 10px;\n    padding: 16px 24px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    position: relative;\n}\n\n.payment-submit-button:hover:not(:disabled) {\n    background-color: #8F3B9F;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(161, 69, 176, 0.3);\n}\n\n.payment-submit-button:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.payment-submit-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.payment-spinner {\n    width: 20px;\n    height: 20px;\n    border: 3px solid rgba(255, 255, 255, 0.3);\n    border-top-color: #FFFFFF;\n    border-radius: 50%;\n    animation: payment-spinner-rotate 0.8s linear infinite;\n}\n\n.payment-spinner.hidden,\n.payment-button-text.hidden,\n.payment-message.hidden {\n    display: none;\n}\n\n.payment-button-text {\n    display: inline-block;\n}\n\n.payment-message {\n    width: 100%;\n    padding: 12px 16px;\n    background-color: #1A1A1A;\n    border: 1px solid #333333;\n    border-radius: 8px;\n    color: #FFFFFF;\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 1.4;\n}\n\n.payment-message.error {\n    background-color: #2A1A1A;\n    border-color: #ff6b6b;\n    color: #ff6b6b;\n}\n\n/* Payment Accordion */\n.accordion {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n}\n\n.accordion .item {\n    margin-bottom: 8px;\n    background: #fff;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.accordion .item:hover {\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n}\n\n.accordion .item[data-state=\"hidden\"] {\n    margin-bottom: 0px;\n    display: none;\n    height: 0px;\n}\n\n.accordion .trigger {\n    width: 100%;\n    background: transparent;\n    border: 0;\n    padding: 20px 14px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    cursor: pointer;\n    color: #333;\n    font-size: 16px;\n    transition: all 0.2s ease;\n}\n\n.accordion .trigger:hover {\n    background: #f8f8f8;\n}\n\n.accordion .item[data-state=\"expanded\"] .trigger {\n    background: transparent;\n}\n\n.accordion .radio-circle {\n    width: 24px;\n    height: 24px;\n    border: 2px solid #d0d0d0;\n    border-radius: 50%;\n    position: relative;\n    flex-shrink: 0;\n    transition: all 0.2s ease;\n}\n\n.accordion .item[data-state=\"expanded\"] .radio-circle {\n    border-color: #333;\n    border-width: 2px;\n}\n\n.accordion .item[data-state=\"expanded\"] .radio-circle::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 12px;\n    height: 12px;\n    background: #333;\n    border-radius: 50%;\n}\n\n.accordion .payment-icons {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.accordion .image-wrap {\n    display: inline-flex;\n    align-items: center;\n}\n\n.accordion .payment-method-icon {\n    height: 24px;\n    width: auto;\n}\n\n.accordion .panel-wrapper {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.accordion .panel {\n    color: #666;\n    font-size: 14px;\n    line-height: 1.6;\n    padding: 0 12px;\n}\n\n.accordion .bullets {\n    list-style: none;\n    padding: 0 10px;\n    margin: 16px 0;\n}\n\n.accordion .bullet {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 12px;\n    color: #000;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.accordion .bullet span {}\n\n.accordion .bullet svg {\n    flex-shrink: 0;\n    margin-top: 2px;\n}\n\n.accordion .checkmark {\n    stroke: #000;\n}\n\n.accordion .container.svelte-ykx1g {\n    margin: 16px 0;\n}\n\n.accordion button.svelte-1wws8ka {\n    line-height: 1.3;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 16px;\n    background-color: #000;\n    border-radius: 16px;\n    border-width: 0;\n    border-style: solid;\n    width: 100%;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n    margin-top: 16px;\n    margin-bottom: 16px;\n    transition: all 0.2s ease;\n}\n\n.accordion button.svelte-1wws8ka:hover {\n    background: #333;\n    transform: translateY(-1px);\n}\n\n.accordion .svelte-lss1u3 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n.accordion .footer {\n    font-size: 14px;\n    line-height: 1;\n    text-align: center;\n    color: #999;\n    margin-bottom: 16px;\n}\n\n/* Card element */\n#card-element {\n    background: #fff;\n    border-radius: 8px;\n    min-height: 50px;\n    margin-bottom: 16px;\n}\n\n#card-errors {\n    color: #ff6b6b;\n    font-size: 14px;\n    margin-top: 8px;\n    min-height: 20px;\n}\n\n#pay-btn {\n    width: 100%;\n    padding: 14px 16px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    background: #000;\n    color: #fff;\n    margin-left: auto;\n    margin-right: auto;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 15px;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    transition: all 0.2s ease;\n}\n\n#pay-btn:hover:not(:disabled) {\n    background: #333;\n    transform: translateY(-1px);\n}\n\n#pay-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Payment loader spinner */\n#payment-form-loader.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid #ccc;\n    border-top-color: #000;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin: 40px auto;\n}\n\n.applePayButton {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.other-payment-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    height: 60px;\n    width: 100%;\n    background-color: #000000;\n    color: #EAEAEA;\n    border: none;\n    border-radius: 10px;\n    padding: 10px 0px;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    text-align: center;\n}\n\n.other-payment-button h1 {\n    font-size: clamp(2px, 16px, 16px);\n    white-space: nowrap;\n}\n\n#solid-payment-form-iframe {\n    width: 100%;\n}\n\n#gpay-button-online-api-id {\n    border-radius: 10px;\n}\n\n#apple-pay {\n    border-radius: 10px;\n}\n\n.apple-pay-button-white {\n    background: #A145B0;\n}\n\napple-pay-button {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
